<template>
  <div>
    <v-text-field
      v-model="billCode"
      :rules="[$rules.required]"
      class="required"
      label="Mã hóa đơn"
      dense
      outlined
    ></v-text-field>
    <v-text-field v-model="doCode" label="Mã phiếu / DO" dense outlined></v-text-field>
    <v-text-field v-model="poCode" label="Mã đơn / PO" dense outlined></v-text-field>
    <Confirm
      ref="confirmCheckBillCode"
      @option1="() => save({ ...dataUpdate, reset: false })"
      @option2="openPickBillCode"
    />
    <PickBillCode ref="pickBillCode" @accept="confirmPickBillCode" />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import PickBillCode from './PickBillCode.vue'
import Confirm from '@/components/plugin/Confirm.vue'
export default {
  name: 'UpdateInfoMany',
  components: { PickBillCode, Confirm },
  data() {
    return {
      billCode: '',
      doCode: '',
      poCode: '',
      dataUpdate: {}
    }
  },
  methods: {
    ...mapActions({
      countItems: 'importDeliveryProduct/countItems',
      updateManyItems: 'auditProducts/updateAuditModelCode'
    }),
    getData() {
      if (!this.billCode) return null
      return {
        billCode: this.billCode,
        doCode: this.doCode,
        poCode: this.poCode
      }
    },
    async onSave(productList) {
      try {
        this.$loading.active = true
        const data = this.getData()
        if (data === null) {
          this.$alert.error('Vui lòng nhập mã hoá đơn')
          this.$loading.active = false
          return
        }
        this.dataUpdate = { ...data, listModel: productList }
        const countBill = await this.countItems({ importCheck: this.$route.params.id, billCode: data.billCode })
        this.$loading.active = false
        if (countBill === 0) {
          this.$refs.confirmCheckBillCode.show({
            title: 'Mã hoá đơn chưa tồn tại trong đơn kiểm hàng',
            message: 'Mã hoá đơn bạn nhập chưa tồn tại trong đơn kiểm hàng, bạn có tạo một hoá đơn mới không?',
            ok1Text: 'Có',
            ok2Text: 'Không',
            cancelText: 'Huỷ',
            data
          })
        }
        if (countBill > 0) {
          this.save(this.dataUpdate)
        }
      } catch (error) {
        this.$alert.error('Có lỗi xảy ra')
      } finally {
        this.$loading.active = false
      }
    },
    async openPickBillCode() {
      this.$refs.pickBillCode.openDialog(this.$route.params.id)
    },
    confirmPickBillCode(billCode) {
      this.dataUpdate.billCode = billCode
      this.dataUpdate.reset = true
      this.save(this.dataUpdate)
    },
    async save(data) {
      try {
        this.$loading.active = true
        await this.updateManyItems({ importCheck: this.$route.params.id, ...data })
        this.$alert.success('Cập nhật thành công')
        this.$emit('refresh')
      } catch (error) {
        this.$alert.error('Có lỗi xảy ra')
      } finally {
        this.$loading.active = false
      }
    },
    resetData() {
      this.billCode = ''
      this.doCode = ''
      this.poCode = ''
    }
  }
}
</script>
